import { Component } from '@angular/core';
import { SOLUTION_PAGE_CONFIGS } from 'src/app/shared/components/solution-page/solution-page.config';

@Component({
  selector: 'app-solution4',
  templateUrl: './solution4.component.html',
  styleUrls: ['./solution4.component.scss'],
})
export class Solution4Component {
  readonly pageConfig = SOLUTION_PAGE_CONFIGS[4];
}
